import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-test"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]

import { computed, onMounted, getCurrentInstance, useSlots, ref, nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'session-slide',
  props: {
    id: {},
    showTextBackground: { type: Boolean },
    visualPosition: {},
    textPosition: {},
    isLastSlide: { type: Boolean },
    classScene: { type: Function }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const instance = getCurrentInstance()?.proxy;
const session = instance?.$parent;

const slots = useSlots();

const visualPosition = computed(() => props.visualPosition ?? "relative");
const textPosition = computed(() => props.textPosition ?? "relative");
const isLastSlide = computed(() => props.isLastSlide ?? false);
const hasVisual = computed(() => !!slots.visual);

const visualDiv = ref<HTMLElement | null>(null);
const sessionSlideRoot = ref<HTMLElement | null>(null);
const slideWrapper = ref<HTMLElement | null>(null);
const slideInner = ref<HTMLElement | null>(null);
const visualRelativePoint = ref<HTMLElement | null>(null);
const visualFixedAgainPoint = ref<HTMLElement | null>(null);
const visualReadyToRecenterPoint = ref<HTMLElement | null>(null);
const slideWrapperFixedPoint = ref<HTMLElement | null>(null);
const slideWrapperRelativeAgainPoint = ref<HTMLElement | null>(null);

const isDynamic = computed(() => visualPosition.value === "dynamic");

// The point of this proprety is to say "I am a session slide! and for the slide to identify itself"
const slideId = computed(() => props.id);

onMounted(() => {
  nextTick(() => {
    if (hasVisual.value && isDynamic.value) {
      // Locking and unlocking the strengths list. We want this completely outside the main timeline because of bugs.
      props.classScene!(
        visualRelativePoint.value as HTMLElement,
        visualDiv.value as HTMLElement,
        "visual-relative",
        0,
      );

      props.classScene!(
        visualFixedAgainPoint.value as HTMLElement,
        visualDiv.value as HTMLElement,
        "visual-fixed-again",
        0,
      );

      props.classScene!(
        visualReadyToRecenterPoint.value as HTMLElement,
        visualDiv.value as HTMLElement,
        "visual-ready-to-recenter",
        0,
      );
    }

    if (hasVisual.value && textPosition.value === "dynamic" && !(session as any).isInline) {
      props.classScene!(
        slideWrapperFixedPoint.value as HTMLElement,
        slideWrapper.value as HTMLElement,
        "slide-wrapper-fixed",
        1,
      );

      props.classScene!(
        slideWrapperRelativeAgainPoint.value as HTMLElement,
        slideWrapper.value as HTMLElement,
        "slide-wrapper-relative-again",
        1,
      );
    }
  });
});

__expose({
  visualDiv,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: _normalizeClass(["session-slide", {
      'session-slide-relative-visual': hasVisual.value && visualPosition.value != 'fixed',
      'last-slide': isLastSlide.value,
    }]),
    ref_key: "sessionSlideRoot",
    ref: sessionSlideRoot
  }, [
    (textPosition.value === 'dynamic')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "slide-wrapper-fixed-point",
          ref_key: "slideWrapperFixedPoint",
          ref: slideWrapperFixedPoint
        }, null, 512))
      : _createCommentVNode("", true),
    (textPosition.value === 'dynamic')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "slide-wrapper-relative-again-point",
          ref_key: "slideWrapperRelativeAgainPoint",
          ref: slideWrapperRelativeAgainPoint
        }, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["slide-wrapper", {
        'no-text-slide': textPosition.value === 'hidden',
        'full-screen-text': textPosition.value === 'fullScreen',
        'show-text-background': !!_ctx.showTextBackground,
      }]),
      ref_key: "slideWrapper",
      ref: slideWrapper,
      "data-test": `slide-wrapper-${_ctx.id}`
    }, [
      _createElementVNode("div", {
        class: "slide-inner",
        ref_key: "slideInner",
        ref: slideInner,
        id: _ctx.id + '-inner'
      }, [
        _renderSlot(_ctx.$slots, "text")
      ], 8, _hoisted_3)
    ], 10, _hoisted_2),
    (hasVisual.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "slide-visual-wrapper",
          id: _ctx.id + '-visual-wrapper'
        }, [
          (isDynamic.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "visualFixedAgainPoint",
                ref: visualFixedAgainPoint,
                class: "visual-fixed-again-point"
              }, null, 512))
            : _createCommentVNode("", true),
          (isDynamic.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref_key: "visualReadyToRecenterPoint",
                ref: visualReadyToRecenterPoint,
                class: "visual-ready-to-recenter-point"
              }, null, 512))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            ref_key: "visualRelativePoint",
            ref: visualRelativePoint,
            class: "visual-relative-point"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["visual side-visual text-center", { 'visual-always-relative': visualPosition.value === 'relative' }]),
              ref_key: "visualDiv",
              ref: visualDiv,
              id: _ctx.id + '-visual'
            }, [
              _renderSlot(_ctx.$slots, "visual")
            ], 10, _hoisted_5)
          ], 512)
        ], 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})